import { enableVirtualBg } from 'flags'

// function to check if desktop safari version is older than 12.1
export function isOldDesktopSafariVersion(userAgent) {
  const isDesktopSafari =
    /safari/i.test(userAgent) &&
    !/(iphone|ipad|android)/i.test(userAgent) &&
    !/chrome/i.test(userAgent) &&
    !/edge/i.test(userAgent)

  if (!isDesktopSafari) {
    return false
  }

  const matchingStrings = userAgent.match('Version[ /]+[0-9]+(.[0-9]+)*')

  const versionNumber =
    matchingStrings.length > 0 ? matchingStrings[0].split('/')[1] : undefined

  const versionWithoutPatch =
    versionNumber && versionNumber.match(/\./g).length > 1
      ? versionNumber.substr(0, versionNumber.lastIndexOf('.'))
      : versionNumber

  if (!versionWithoutPatch) {
    return false
  }
  return parseFloat(versionWithoutPatch) < 14.1
}

// Export used only in the Flash recorder which will be removed
export const IS_CHROME =
  /chrome/i.test(navigator.userAgent) && !/edge/i.test(navigator.userAgent)

// Export used only in some IE clipboard support which will be removed / simplified
export const IS_IE =
  navigator.appName === 'Microsoft Internet Explorer' ||
  (navigator.appName === 'Netscape' &&
    !!navigator.userAgent.match(/Trident\/7\./))

const IS_OSX_10_12 = /OS X 10.[1-9][2-9]/i.test(navigator.userAgent)

const IS_FIREFOX = /firefox/i.test(navigator.userAgent)

const IS_MOBILE = !!navigator.userAgent.match(/(iphone|ipad|android)/i)

export const IS_OLD_DESKTOP_SAFARI = isOldDesktopSafariVersion(
  navigator.userAgent
)


export const IS_DESKTOP_SAFARI =
  !IS_MOBILE &&
  !IS_CHROME &&
  /safari/i.test(navigator.userAgent) &&
  !/edge/i.test(navigator.userAgent)

export const IS_NEWER_SAFARI = IS_DESKTOP_SAFARI && !IS_OLD_DESKTOP_SAFARI
export const SHOW_BROWSER_SUPPORT_REMINDER = IS_DESKTOP_SAFARI

// Actual feature logic

export const USE_WEBRTC_RECORDER =
  (IS_CHROME || IS_FIREFOX || IS_NEWER_SAFARI) &&
  navigator.mediaDevices &&
  navigator.mediaDevices.getUserMedia

export const USE_FILE_UPLOAD =
  IS_MOBILE ||
  !USE_WEBRTC_RECORDER ||
  IS_OLD_DESKTOP_SAFARI ||
  !!window.location.hash.match(/upload/)

export const USE_HIGH_QUALITY_VIDEO_RECORDING =
  (IS_FIREFOX && IS_OSX_10_12) || IS_NEWER_SAFARI

export const IS_VIRTUAL_BG_SUPPORTED =
  enableVirtualBg() && !IS_FIREFOX && !IS_MOBILE && !IS_DESKTOP_SAFARI // Mobile uses different view but just in case, and disable in safari for now as it's not working that well there

export const IS_VIRTUAL_BG_BLUR_SUPPORTED = !IS_NEWER_SAFARI
export const USE_MEDIA_RECORDER_FOR_VIRTUAL_BG = true // turn media recorder for virtual bg on/off, if some issues arise
